module.exports = __webpack_public_path__ + "static/img/yellow-left.4138898.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/yellow-left.png
// module id = ijCz
// module chunks = 0